import { ReactNode } from "react";
import HeroIntroPublic from "@/app/features/shared/intros/hero/ui/public/HeroIntro.public";
import { Divider, Stack } from "@mui/material";
import SnapSectionsContainer from "@/app/features/shared/snap-section/SnapSectionsContainer";
import Section from "@/app/features/shared/snap-section/Section";

export function AuthenticPlacesRootFrame({ children }: { children: ReactNode}) {
    return (
        <SnapSectionsContainer>
            {children}
        </SnapSectionsContainer>
    )
}

export function AuthenticPlacesHeroFrame({ content, background }: { content: ReactNode, background: ReactNode }) {
    return (
        <Section className="relative w-full">
            <HeroIntroPublic
                content={content}
                background={background}
            />
        </Section>
    )
}

export function AuthenticPlacesSectionFrame({
    children,
    sectionId,
    headingId
}: {
    children: ReactNode,
    sectionId: string,
    headingId: string
}) {
    return (
        <>
            <Divider sx={{ m: 4 }} />
            <Section id={sectionId} aria-labelledby={headingId} className="relative w-full" >
                {children}
            </Section>
        </>
    )
}

export function AuthenticPlacesSectionContentFrame({ children }: { children: ReactNode }) {
    return (
            <Stack
                className="flex flex-auto size-full overflow-hidden"
                spacing={2}
            >
                {children}
            </Stack>

    )
}
